import { useEffect, useState } from "react";
import { Moment } from "moment";
import moment from "moment";
import ReactECharts from "echarts-for-react";
import "./weekly-insights.scss";
import { FollowerType } from "types";

function WeeklyInsights({ data, streamIds, dateFrom, dateTo }: { data: FollowerType[]; streamIds: number[]; dateFrom: Moment; dateTo: Moment }) {
    const [chartData, setChartData] = useState<any[]>([]);
    const [xAxis, setXAxis] = useState<string[]>([]);
    const [legend, setLegend] = useState<string[]>([]);

    const getStreamId = (stream: string) => {
        switch (stream) {
            case "Twitter":
                return 7;
            case "Facebook":
                return 8;
            case "Instagram":
                return 9;
            case "Youtube":
                return 10;
            case "Linkedin":
                return 11;
            default:
                return 0;
        }
    };

    const getStream = (stream: string) => {
        switch (stream) {
            case "Twitter":
                return {
                    color: "#000",
                };
            case "Facebook":
                return {
                    color: "#3b5998",
                };
            case "Instagram":
                return {
                    color: "#e1306c",
                };
            case "Youtube":
                return {
                    color: "#f61c0d",
                };
            case "Linkedin":
                return {
                    color: "#2977c9",
                };
            default:
                return {
                    color: "#5cb85c",
                };
        }
    };

    useEffect(() => {
        let arr: any[] = [];
        let _xAxis: string[] = [];

        for (var i = moment(dateFrom); i.isSameOrBefore(dateTo.clone().add(7, "d")); i.add(7, "d")) {
            let dtFrom = i.isoWeekday(1);
            let dtTo = i.clone().add(8, "d");

            if (dtTo > moment()) {
                dtTo = moment();
            }
            dtTo = dtTo.isoWeekday(1);

            let bfound = false;
            _xAxis.forEach((x) => {
                if (moment(x).format("YYYY-MM-DD") == dtTo.format("YYYY-MM-DD").toString()) {
                    bfound = true;
                }

                //console.log(moment(x).format("YYYY-MM-DD"));
                //console.log(dtTo.format("YYYY-MM-DD").toString())
            });

            if (!bfound) {
                _xAxis.push(`${dtTo.format("D MMM YYYY")}`);
            }
            //_xAxis.push(`${dtFrom.format("D MMM YYYY")} - ${dtTo.format("D MMM YYYY")}`);
            setXAxis(_xAxis);
        }

        for (let i = 0; i < legend.length; i++) {
            arr.push([]);
            for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo.clone().add(7, "d")); j.add(7, "days")) {
                let dtFrom = j;
                let dtTo = j.clone().add(6, "d");
                if (dtTo > moment()) {
                    dtTo = moment();
                }
                if (data.length > 0) {
                    const c = data.filter((x) => x.StreamId === getStreamId(legend[i]) && (moment(x.DateCaptured).isBetween(dtFrom, dtTo) || moment(x.DateCaptured).isSame(moment(dtFrom).set("h", 0).set("m", 0).set("s", 0).set("ms", 0))));

                    if (c.length > 0) {
                        arr[i].push(c[0].FollowerCount);
                    } else {
                        arr[i].push(0);
                    }
                    setChartData(arr);
                }
            }
        }
    }, [dateFrom, dateTo, data, legend]);

    useEffect(() => {
        var streams: string[] = [];

        for (var stream of streamIds) {
            switch (stream) {
                case 7:
                    streams.push("X");
                    break;
                case 8:
                    streams.push("Facebook");
                    break;
                case 9:
                    streams.push("Instagram");
                    break;
                case 10:
                    streams.push("Youtube");
                    break;
                case 11:
                    streams.push("Linkedin");
                    break;
            }
        }
        setLegend(streams);
    }, [streamIds]);

    return (
        <div className="weekly-insights component">
            <div className="top">
                <p>Weekly Insights</p>
            </div>
            <div className="body">
                {
                    <ReactECharts
                        notMerge={true}
                        option={{
                            tooltip: {},
                            legend: {
                                data: legend,
                                top: 10,
                            },
                            grid: {
                                left: 60,
                                right: 10,
                                top: 45,
                                bottom: 20,
                            },
                            xAxis: {
                                data: xAxis,
                            },
                            yAxis: {
                                minInterval: 1,
                            },
                            series: legend.map((x: string, i: number) => {
                                return {
                                    name: x,
                                    type: "line",
                                    color: getStream(x).color,
                                    data: chartData[i],
                                };
                            }),
                        }}
                    />
                }
            </div>
        </div>
    );
}

export default WeeklyInsights;
